// Sample grades data for demonstration
export const gradesData = [
  {
    studentId: 'S001',
    studentName: '張小明',
    class: '6A',
    subjects: [
      {
        name: '中文',
        englishName: 'Chinese',
        grade: 'A',
        score: 85,
        maxScore: 100,
        rank: 3,
        teacher: '陳老師',
        semester: '2024-1',
        comments: '寫作能力優秀，需要加強口語表達'
      },
      {
        name: '英文',
        englishName: 'English',
        grade: 'B+',
        score: 78,
        maxScore: 100,
        rank: 8,
        teacher: '李老師',
        semester: '2024-1',
        comments: '閱讀理解良好，寫作需要改善'
      },
      {
        name: '數學',
        englishName: 'Mathematics',
        grade: 'A+',
        score: 92,
        maxScore: 100,
        rank: 1,
        teacher: '王老師',
        semester: '2024-1',
        comments: '數學思維優秀，解題能力強'
      },
      {
        name: '科學',
        englishName: 'Science',
        grade: 'A',
        score: 88,
        maxScore: 100,
        rank: 2,
        teacher: '張老師',
        semester: '2024-1',
        comments: '實驗能力優秀，理論基礎紮實'
      },
      {
        name: '體育',
        englishName: 'Physical Education',
        grade: 'A',
        score: 90,
        maxScore: 100,
        rank: 1,
        teacher: '劉老師',
        semester: '2024-1',
        comments: '運動技能優秀，團隊合作精神好'
      }
    ]
  },
  {
    studentId: 'S002',
    studentName: '李小華',
    class: '6A',
    subjects: [
      {
        name: '中文',
        englishName: 'Chinese',
        grade: 'B+',
        score: 82,
        maxScore: 100,
        rank: 5,
        teacher: '陳老師',
        semester: '2024-1',
        comments: '寫作能力良好，需要加強閱讀理解'
      },
      {
        name: '英文',
        englishName: 'English',
        grade: 'A',
        score: 85,
        maxScore: 100,
        rank: 3,
        teacher: '李老師',
        semester: '2024-1',
        comments: '口語表達優秀，寫作能力良好'
      },
      {
        name: '數學',
        englishName: 'Mathematics',
        grade: 'B+',
        score: 80,
        maxScore: 100,
        rank: 6,
        teacher: '王老師',
        semester: '2024-1',
        comments: '基礎概念清晰，需要加強應用題'
      },
      {
        name: '科學',
        englishName: 'Science',
        grade: 'B',
        score: 75,
        maxScore: 100,
        rank: 7,
        teacher: '張老師',
        semester: '2024-1',
        comments: '理論基礎良好，實驗能力需要改善'
      },
      {
        name: '美術',
        englishName: 'Art',
        grade: 'A+',
        score: 95,
        maxScore: 100,
        rank: 1,
        teacher: '林老師',
        semester: '2024-1',
        comments: '創意天賦突出，藝術表現優秀'
      }
    ]
  },
  {
    studentId: 'S003',
    studentName: '王小美',
    class: '6A',
    subjects: [
      {
        name: '中文',
        englishName: 'Chinese',
        grade: 'B',
        score: 78,
        maxScore: 100,
        rank: 7,
        teacher: '陳老師',
        semester: '2024-1',
        comments: '基礎知識紮實，需要加強寫作'
      },
      {
        name: '英文',
        englishName: 'English',
        grade: 'B+',
        score: 82,
        maxScore: 100,
        rank: 5,
        teacher: '李老師',
        semester: '2024-1',
        comments: '聽力理解良好，口語需要改善'
      },
      {
        name: '數學',
        englishName: 'Mathematics',
        grade: 'B',
        score: 76,
        maxScore: 100,
        rank: 8,
        teacher: '王老師',
        semester: '2024-1',
        comments: '計算能力良好，邏輯思維需要加強'
      },
      {
        name: '科學',
        englishName: 'Science',
        grade: 'B+',
        score: 80,
        maxScore: 100,
        rank: 6,
        teacher: '張老師',
        semester: '2024-1',
        comments: '實驗操作熟練，理論理解需要改善'
      },
      {
        name: '音樂',
        englishName: 'Music',
        grade: 'A+',
        score: 93,
        maxScore: 100,
        rank: 1,
        teacher: '黃老師',
        semester: '2024-1',
        comments: '音樂天賦優秀，演奏技巧高超'
      }
    ]
  },
  {
    studentId: 'S004',
    studentName: '陳小強',
    class: '6A',
    subjects: [
      {
        name: '中文',
        englishName: 'Chinese',
        grade: 'B',
        score: 75,
        maxScore: 100,
        rank: 8,
        teacher: '陳老師',
        semester: '2024-1',
        comments: '基礎知識需要加強，寫作能力一般'
      },
      {
        name: '英文',
        englishName: 'English',
        grade: 'C+',
        score: 68,
        maxScore: 100,
        rank: 10,
        teacher: '李老師',
        semester: '2024-1',
        comments: '需要加強詞彙量，語法基礎薄弱'
      },
      {
        name: '數學',
        englishName: 'Mathematics',
        grade: 'A',
        score: 86,
        maxScore: 100,
        rank: 4,
        teacher: '王老師',
        semester: '2024-1',
        comments: '數學思維清晰，解題能力良好'
      },
      {
        name: '科學',
        englishName: 'Science',
        grade: 'B+',
        score: 82,
        maxScore: 100,
        rank: 5,
        teacher: '張老師',
        semester: '2024-1',
        comments: '實驗能力優秀，理論理解需要改善'
      },
      {
        name: '體育',
        englishName: 'Physical Education',
        grade: 'A+',
        score: 94,
        maxScore: 100,
        rank: 1,
        teacher: '劉老師',
        semester: '2024-1',
        comments: '運動天賦突出，領導能力優秀'
      }
    ]
  },
  {
    studentId: 'S005',
    studentName: '劉小芳',
    class: '6A',
    subjects: [
      {
        name: '中文',
        englishName: 'Chinese',
        grade: 'A',
        score: 87,
        maxScore: 100,
        rank: 2,
        teacher: '陳老師',
        semester: '2024-1',
        comments: '文學素養優秀，寫作風格獨特'
      },
      {
        name: '英文',
        englishName: 'English',
        grade: 'A+',
        score: 91,
        maxScore: 100,
        rank: 1,
        teacher: '李老師',
        semester: '2024-1',
        comments: '英語能力全面，口語寫作俱佳'
      },
      {
        name: '數學',
        englishName: 'Mathematics',
        grade: 'A',
        score: 88,
        maxScore: 100,
        rank: 3,
        teacher: '王老師',
        semester: '2024-1',
        comments: '數學思維敏捷，解題方法多樣'
      },
      {
        name: '科學',
        englishName: 'Science',
        grade: 'A+',
        score: 93,
        maxScore: 100,
        rank: 1,
        teacher: '張老師',
        semester: '2024-1',
        comments: '科學素養優秀，創新思維突出'
      },
      {
        name: '電腦',
        englishName: 'Computer',
        grade: 'A',
        score: 89,
        maxScore: 100,
        rank: 2,
        teacher: '何老師',
        semester: '2024-1',
        comments: '程式設計能力優秀，邏輯思維清晰'
      }
    ]
  }
];

// Helper function to get grades by student ID
export const getGradesByStudent = (studentId) => {
  return gradesData.find(student => student.studentId === studentId);
};

// Helper function to get grades by class
export const getGradesByClass = (className) => {
  return gradesData.filter(student => student.class === className);
};

// Helper function to get grades by subject
export const getGradesBySubject = (subjectName) => {
  const subjectGrades = [];
  gradesData.forEach(student => {
    const subject = student.subjects.find(sub => sub.name === subjectName);
    if (subject) {
      subjectGrades.push({
        studentId: student.studentId,
        studentName: student.studentName,
        class: student.class,
        ...subject
      });
    }
  });
  return subjectGrades;
};

// Helper function to calculate average score
export const calculateAverageScore = (scores) => {
  if (!Array.isArray(scores) || scores.length === 0) return 0;
  const sum = scores.reduce((acc, score) => acc + score, 0);
  return Math.round((sum / scores.length) * 100) / 100;
};

// Helper function to get grade letter from score
export const getGradeLetter = (score) => {
  if (score >= 90) return 'A+';
  if (score >= 85) return 'A';
  if (score >= 80) return 'B+';
  if (score >= 75) return 'B';
  if (score >= 70) return 'C+';
  if (score >= 65) return 'C';
  if (score >= 60) return 'D';
  return 'F';
};
